/**
 * RegionalTeachers — bucket 3 of 6: the tab shell for the staffing surface.
 * Roster (BON-83, in RegionalTeachersRoster) | Shift board (BON-240).
 * Confirmations (BON-243) and Availability (BON-241) slot in as they land.
 * The strip renders in ALL states so one tab's failing fetch can't lock the
 * user out of the other, independent tab.
 */
import { useState } from 'react';

import { SegmentedControl } from '../primitives';

import type { RegionalBucketProps } from './regional-bucket';
import RegionalShiftBoard from './RegionalShiftBoard';
import RegionalTeachersRoster from './RegionalTeachersRoster';

type TeachersTab = 'roster' | 'board';
const TAB_OPTIONS: ReadonlyArray<{ value: TeachersTab; label: string }> = [
  { value: 'roster', label: 'Roster' },
  { value: 'board', label: 'Shift board' },
];

export function RegionalTeachers({ regionSlug }: RegionalBucketProps) {
  const [tab, setTab] = useState<TeachersTab>('roster');

  return (
    <>
      <div style={{ display: 'flex' }}>
        <SegmentedControl
          value={tab}
          onChange={setTab}
          options={TAB_OPTIONS}
          ariaLabel="Teachers view"
        />
      </div>
      {tab === 'board' ? (
        <RegionalShiftBoard regionSlug={regionSlug} />
      ) : (
        <RegionalTeachersRoster regionSlug={regionSlug} />
      )}
    </>
  );
}
